import React from 'react';
import LoginForm from '../components/common/LoginForm';

const LoginPage = () => {
  return <LoginForm />;
};

export default LoginPage;